<template>
    <div :id="'customersCarousel'+ ($root.alias_pais != 'col' ? 'All' : '')" class="carousel">
        <div class="carousel-row" v-for="(row, index) in ($root.alias_pais == 'col' ? carouselCol.rows : carouselAll.rows)" :key="index">
            <img v-for="(imgSrc, idxImgSrc) in row" :src="`/img/customers/${imgSrc}`" :alt="imgSrc.split('.png')[0]" :key="`${index}-${idxImgSrc}`">
        </div>
    </div>
</template>
<script>
export default {
    name: 'customers-carousel',
    data() {
        return {
            carouselCol: {
                rows: [
                    [
                        'Alianza.png',
                        'Apolo.png',
                        'Areaandina.png',
                        'Argos.png',
                        'Aseguradora solidaria.png',
                        'Bancolombia.png',
                        'Camacol.png',
                        'Caracol radio.png',
                        'Cavelier.png',
                        'Ceder.png',
                        'Colpatria construxtora.png',
                        'Colpatria fiduciaria.png',
                        'Cruz roja.png',
                        'Custodia.png',
                        'Davivienda.png',
                        'Dobleclick.png',
                        'Doxa.png',
                        'Egis.png'
                    ],
                    [
                        'El bosque.png',
                        'El espectador.png',
                        'EPM.png',
                        'Epson.png',
                        'Faber Castell.png',
                        'Fiduagraria.png',
                        'GBarco.png',
                        'GCSI.png',
                        'Global SAT.png',
                        'Hospitécnica.png',
                        'Icontec.png',
                        'Indra.png',
                        'Interactuar.png',
                        'IT Synergy.png',
                        'Itaca.png',
                        'Javeriana.png',
                        'La urbe.png',
                        'Learn.png'
                    ],
                    [
                        'Minepro.png',
                        'Multicomputo.png',
                        'Nexys.png',
                        'Oracle.png',
                        'Panamericana.png',
                        'Parque Soft.png',
                        'Philips.png',
                        'Praxair.png',
                        'QHSE.png',
                        'Rentainer.png',
                        'RUA.png',
                        'Sergio arboleda.png',
                        'Servientrega.png',
                        'Siemens.png',
                        'Sodexo.png',
                        'Telefonica.png',
                        'Thomas.png',
                        'Ticsa.png',
                        'Tubosa.png'
                    ]
                ]
            },
            carouselAll: {
                rows: [
                    [
                        'Philips.png',
                        'Hyundai.png',
                        'Sudinco.png',
                        'Cruz roja peru.png',
                        'veolia.png',
                        'Latam.png',
                        'Iberia.png',
                        'Kruger.png',
                        'Hytsa.png',
                        'Micronet.png',
                        'Praxair.png',
                        'Sodexo.png',
                    ],
                    [
                        'Cemosa.png',
                        'Buffalo.png',
                        'Smart mobility.png',
                        'Axess.png',
                        'Atento.png',
                        'Buysoft.png',
                        'Eurecat.png',
                        'Serman.png',
                        'Latinoconsult.png',
                        'tnm.png',
                        'Indra.png',
                        'Nexsys.png',
                        '3M.png',
                    ],
                    [
                        'Durman.png',
                        'Bmind.png',
                        'Siemens.png',
                        'HP.png',
                        'Faber castell.png',
                        'Argos peru.png',
                        'Epson.png',
                        'Samsung.png',
                        'Homecenter.png',
                        'BBVA.png',
                        'Servientrega peru.png',
                        'Oracle.png',
                    ]
                ]
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    #customersCarousel {
        overflow: hidden;
        img {
            margin-right: 44px;
            width: 136px;
        }
        .carousel {
            display: flex;
            flex-direction: column;
            &-row {
                animation: carousel-backward 20s linear infinite;
                display: flex;
                &:nth-child(odd) {
                    animation: carousel-forward 20s linear infinite;
                }
            }
        }
        @keyframes carousel-forward {
            0% { transform: translateX(0); }
            100% { transform: translateX(calc(-136px * 20)); }
        }
        @keyframes carousel-backward {
            0% { transform: translateX(calc(-136px * 20)); }
            100% { transform: translateX(0); }
        }
    }

    #customersCarouselAll {
        overflow: hidden;
        img {
            margin-right: 36px;
            width: 136px;
        }
        .carousel {
            display: flex;
            flex-direction: column;
            &-row {
                animation: carousel-backward 20s linear infinite;
                display: flex;
                &:nth-child(odd) {
                    animation: carousel-forward 20s linear infinite;
                }
            }
        }
        @keyframes carousel-forward {
            0% { transform: translateX(0); }
            100% { transform: translateX(calc(-75px * 20)); }
        }
        @keyframes carousel-backward {
            0% { transform: translateX(calc(-80px * 20)); }
            100% { transform: translateX(0); }
        }
    }
</style>
